module.exports = __webpack_public_path__ + "img/indu_active_6.e0bf403f.png";